export const chartColumns = [
  {
    field: 'orderCreateDate',
    title: '订单创建时间',
    width: '120',
  },
  {
    field: 'orderCode', ///
    title: '订单编号',
    width: '150',
  },
  {
    field: 'orderStatusName',
    title: '订单状态',
    width: '140',
  },
  {
    field: 'customerName',
    title: '客户名称',
    width: '140',
  },
  {
    field: 'contractName',
    title: '客户合同',
    width: '140',
  },
  {
    field: 'productTypeName',
    title: '产品类型',
    width: '140',
  },
  {
    field: 'serviceTypeName',
    title: '服务类型',
    width: '140',
  },
  {
    field: 'platformCompanyName',
    title: '平台公司',
    width: '140',
  },
  {
    field: 'salesmanName',
    title: '业务员',
    width: '140',
  },
  {
    field: 'orderCreatorName',
    title: '订单创建人',
    width: '140',
  },
];
